//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Detsky_Index",
  data() {
    return {
      form: {
        myocardialInfarct: "",
        anginaPectoris: "",
        anginaPectorisHalfYear: "",
        alveolarPulmonaryEdema: "",
        aorticStenosis: "",
        arrhythmias: "",
        poorMedicalCondition: "",
        age: "",
        emergencyOperation: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "无" },
        { value: "10", name: "心肌梗死发生在6个月内" },
        { value: "5", name: "心肌梗死发生超过6个月" },
      ],
      dataList1: [
        { value: "0", name: "无" },
        { value: "10", name: "Ⅲ级心绞痛" },
        { value: "20", name: "Ⅳ级心绞痛" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "10", name: "有" },
      ],
      dataList3: [
        { value: "0", name: "无" },
        { value: "10", name: "发生在1周内" },
        { value: "5", name: "曾经" },
      ],
      dataList4: [
        { value: "0", name: "无" },
        { value: "20", name: "有" },
      ],
      dataList5: [
        { value: "0", name: "窦性心律或窦性心律伴心房早搏" },
        { value: "5", name: "除窦性心律或窦性心律伴心房早搏外的心律失常" },
        { value: "5.0", name: "超过5次室性早搏" },
      ],
      dataList6: [
        { value: "5", name: "是" },
        { value: "0", name: "不是" },
      ],
      dataList7: [
        { value: "5", name: "＞70岁" },
        { value: "0", name: "≤70岁" },
      ],
      dataList8: [
        { value: "10", name: "是" },
        { value: "0", name: "否" },
      ],
     
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Detsky_Index.vue